import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/registration_fee_cover.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-01a33372"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "offcanvas-body px-0" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "card-img mb-4"
}, null, -1))
const _hoisted_3 = { class: "px-4" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-header" }, "Escolha seu plano", -1))
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "text-subtitle mb-2" }
const _hoisted_8 = { class: "text-paragraph d-flex" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-paragraph" }, " Voltado para quem busca recursos avançados. Oferece maior visibilidade nas buscas, ferramentas de gestão, selo de destaque no perfil, entre outros. ", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_11 = { class: "px-4" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-header" }, "Período", -1))
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "badge bg-secondary position-absolute plan-card-badge" }
const _hoisted_15 = { class: "text-subtitle my-2" }
const _hoisted_16 = { class: "text-paragraph mb-2" }
const _hoisted_17 = { class: "text-paragraph text-muted" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_19 = { class: "px-4" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-header" }, "Principais benefícios", -1))
const _hoisted_21 = { class: "list-group list-group-flush mb-4" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-circle-check text-primary me-2" }, null, -1))
const _hoisted_23 = { class: "text-paragraph mb-0" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-header" }, "Método de pagamento", -1))
const _hoisted_25 = { class: "text-subtitle mb-0" }
const _hoisted_26 = { class: "d-flex align-items-center" }
const _hoisted_27 = {
  key: 0,
  class: "text-paragraph mb-0 me-3"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-chevron-right text-primary" }, null, -1))
const _hoisted_29 = { class: "form-group mb-4" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label text-muted" }, [
  /*#__PURE__*/_createTextVNode("CPF "),
  /*#__PURE__*/_createElementVNode("i", { class: "text-danger" }, "*")
], -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-subtitle" }, "termos de uso.", -1))
const _hoisted_32 = { class: "text-label text-danger text-center" }

import { Plan, PlanPrice, SubsRequest } from "@/@types";
import LoadingContainer from "@/components/LoadingContainer.vue";
import router from "@/router";
import paths from "@/router/paths";
import { subsService } from "@/services";
import { useMainStore } from "@/store";
import { syncSessionUseCase } from "@/useCases";
import { EventBus, EventBusNames } from "@/utils/EventBus";
import { isCPFValid } from "@/utils/FormValidators";
import { cpfMask } from "@/utils/masks";
import {
  closeOffCanvas,
  EOffcanvasViews,
  navigateCanvas,
  OffcanvasViewKey,
} from "@/views/OffcanvasViews/OffcanvasViewsConfig";
import { useMutation, useQuery } from "@tanstack/vue-query";
import { vMaska } from "maska";
import { onMounted, ref, watch } from "vue";
import { useRoute } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'Subscription',
  setup(__props) {

const {
  session,
  subscription_info,
  clearSubscriptionInfo,
  saveSubscriptionInfo,
} = useMainStore();

const errorMessage = ref<string>();

const {
  data: plans,
  isLoading,
  error,
  isSuccess,
} = useQuery({
  queryFn: () => subsService.listPlans(),
  queryKey: ["plans"],
});

const selectedPlan = ref<Plan>();
const selectedPrice = ref<PlanPrice>();
const documentNumber = ref<string>(
  session?.document_number ? cpfMask.execute(session.document_number) : ""
);

onMounted(() => {
  setupPlan();
});

watch(isSuccess, () => setupPlan());

watch(error, () => {
  if (error) errorMessage.value = error.value?.message;
});

const setupPlan = async () => {
  if (plans.value && plans.value.length) {
    selectedPlan.value = subscription_info?.plan || plans.value[0];
    selectedPrice.value = subscription_info?.price || plans.value[0].prices[0];
  }
};

const route = useRoute();

const { isPending, mutateAsync: handleSubscribe } = useMutation({
  mutationFn: (params: SubsRequest) => subsService.subscribe(params),
  onSuccess: async ({ data }) => {
    await syncSessionUseCase.execute();

    if (data?.status === "past_due" || data?.status === "incomplete") {
      alert(
        "Ocorreu um problema ao realizar o pagamento. Por favor, verifique suas informações e tente novamente.",
      );
    } else {
      EventBus.$emit(EventBusNames.SHOW_TOAST, {
        title: "Assinatura realizada",
        msg: `Bem vindo(a) ao ${selectedPlan.value?.title}, você já está usufruindo dos benefícios.`,
      });
    }

    EventBus.$emit(EventBusNames.ON_HOLDING_UPDATE);
    EventBus.$emit(EventBusNames.REFRESH_MY_PLAN);

    clearSubscriptionInfo();
    closeOffCanvas();

    if (route.path === paths.onHolding) {
      router.push(paths.home);
    }
  },
  onError: (error) => {
    errorMessage.value = error.message;
  },
});

const onSubscribe = async () => {
  try {
    if (!selectedPlan.value) {
      errorMessage.value = "Selecione um plano";
      return;
    }
    if (!selectedPrice.value) {
      errorMessage.value = "Selecione um período";
      return;
    }
    // if (
    //   session &&
    //   session.subscription &&
    //   session.subscription.subscription_plan_id === selectedPlan.value.id
    // ) {
    //   errorMessage.value = "Você já é assinante do plano selecionado";
    //   return;
    // }
    if (!session || !session.favorite_card) {
      errorMessage.value = "Selecione um método de pagamento";
      return;
    }

    const rawCpf = documentNumber.value.replace(/\D/g, "");
    if (!isCPFValid(rawCpf)) {
      errorMessage.value = "Informe um CPF válido";
      return;
    }

    errorMessage.value = "";

    const params: SubsRequest = {
      subscription_plan_id: selectedPlan.value.id,
      subscription_plan_price_id: selectedPrice.value.id,
      card_id: session.favorite_card.card_id,
      document_number: rawCpf,
    };

    handleSubscribe(params);
  } catch (error: any) {
    console.error(error);
    errorMessage.value = error.message;
  }
};

const handleSelectPlan = (plan: Plan) => {
  selectedPlan.value = plan;
  selectedPrice.value = plan.prices[0];
  saveSubscriptionInfo({
    plan: plan,
    price: plan.prices[0],
  });
};

const handleSelectPrice = (price: PlanPrice) => {
  selectedPrice.value = price;
  saveSubscriptionInfo({
    plan: selectedPlan.value,
    price: price,
  });
};

const handleCreditCard = () => {
  EventBus.$emit(EventBusNames.GET_CREDIT_CARDS);
  if (session && session.favorite_card) {
    navigateCanvas(
      EOffcanvasViews.credit_cards as OffcanvasViewKey,
      null,
      false,
    );
  } else {
    navigateCanvas(
      EOffcanvasViews.add_credit_card as OffcanvasViewKey,
      null,
      false,
    );
  }
};

const handleTerms = () => {
  navigateCanvas(EOffcanvasViews.terms_of_use, null, false);
};

return (_ctx: any,_cache: any) => {
  const _component_ScrollHorizontal = _resolveComponent("ScrollHorizontal")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_unref(isLoading))
      ? (_openBlock(), _createBlock(LoadingContainer, { key: 0 }))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createVNode(_component_ScrollHorizontal, { items: _unref(plans) }, {
              default: _withCtx(({ item }) => [
                _createElementVNode("div", {
                  class: _normalizeClass([{
                'border-primary': selectedPlan.value?.id === item.id,
              }, "border border-2 border-muted p-3 rounded-4 mb-3 cursor-pointer plan-card"]),
                  onClick: ($event: any) => (handleSelectPlan(item))
                }, [
                  _createElementVNode("img", {
                    src: item.icon,
                    alt: "",
                    class: "mb-2",
                    height: "20"
                  }, null, 8, _hoisted_6),
                  _createElementVNode("p", _hoisted_7, _toDisplayString(item.title), 1),
                  _createElementVNode("p", _hoisted_8, _toDisplayString(item.description_heading), 1)
                ], 10, _hoisted_5)
              ]),
              _: 1
            }, 8, ["items"]),
            _hoisted_9
          ]),
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createVNode(_component_ScrollHorizontal, {
              items: selectedPlan.value?.prices
            }, {
              default: _withCtx(({ item }) => [
                _createElementVNode("div", {
                  class: _normalizeClass([{
                'border-primary': selectedPrice.value?.id === item.id,
              }, "border border-2 border-muted p-3 rounded-4 my-3 cursor-pointer plan-card position-relative"]),
                  onClick: ($event: any) => (handleSelectPrice(item))
                }, [
                  _createElementVNode("span", _hoisted_14, _toDisplayString(item.discount), 1),
                  _createElementVNode("p", _hoisted_15, _toDisplayString(item.title), 1),
                  _createElementVNode("p", _hoisted_16, _toDisplayString(item.value), 1),
                  _createElementVNode("p", _hoisted_17, _toDisplayString(item.description), 1)
                ], 10, _hoisted_13)
              ]),
              _: 1
            }, 8, ["items"])
          ]),
          _hoisted_18,
          _createElementVNode("div", _hoisted_19, [
            _hoisted_20,
            _createElementVNode("ul", _hoisted_21, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedPlan.value?.features, (item) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: item,
                  class: "list-group-item d-flex align-items-center"
                }, [
                  _hoisted_22,
                  _createElementVNode("p", _hoisted_23, _toDisplayString(item), 1)
                ]))
              }), 128))
            ]),
            _hoisted_24,
            _createElementVNode("div", {
              onClick: handleCreditCard,
              class: "border rounded-4 py-3 px-4 d-flex justify-content-between align-items-center cursor-pointer mb-4"
            }, [
              _createElementVNode("p", _hoisted_25, _toDisplayString(_unref(session)?.favorite_card
                ? `**** ${_unref(session).favorite_card.last_digits}`
                : "Adicionar cartão"), 1),
              _createElementVNode("div", _hoisted_26, [
                (_unref(session)?.favorite_card)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_27, " Alterar "))
                  : _createCommentVNode("", true),
                _hoisted_28
              ])
            ]),
            _createElementVNode("div", _hoisted_29, [
              _hoisted_30,
              _withDirectives(_createElementVNode("input", {
                "data-maska": "###.###.###-##",
                type: "text",
                class: "form-control",
                placeholder: "000.000.000-00",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((documentNumber).value = $event))
              }, null, 512), [
                [_unref(vMaska)],
                [_vModelText, documentNumber.value]
              ])
            ]),
            _createElementVNode("p", {
              class: "text-paragraph cursor-pointer",
              onClick: handleTerms
            }, [
              _createTextVNode(" Clicando em assinar, você estará concordando com nossos "),
              _hoisted_31
            ]),
            _createElementVNode("p", _hoisted_32, _toDisplayString(errorMessage.value), 1),
            _createVNode(_component_Button, {
              fullWidth: "",
              loading: _unref(isPending),
              onOnClick: onSubscribe,
              label: `Assinar por ${selectedPrice.value?.value}`
            }, null, 8, ["loading", "label"])
          ])
        ], 64))
  ]))
}
}

})